@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.promocodes

import com.narbase.letsgo.router.EndPoint

object DeactivateRidePromoCodeEndpoint :
    EndPoint<DeactivateRidePromoCodeEndpoint.Request, DeactivateRidePromoCodeEndpoint.Response>() {
    class Request

    class Response
}